// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"f394f7cb","591":"bf95cb4d","685":"6b91b455"}[chunkId] + ".chunk.css";
};